import { MicSetup } from "@/components/blocks/mic-setup/mic-setup";

const MicSetupDemo = () => <MicSetup class="w-full max-w-md" />;

export default MicSetupDemo;
